import { ILanguage } from '../../interface';

const de: ILanguage = {
  locale: 'de',
  translations: {
    notifications: 'Benachrichtigungen',
    markAllAsRead: 'Alle als gelesen markieren',
    noNotificationsTitle: 'Noch keine Benachrichtigungen',
    noNotificationsDescription:
      'Wir informieren Sie, wenn wir etwas Neues für Sie haben.',
    pinned: 'Angepinnt',
    markAsUnread: 'Als ungelesen markieren',
    markAsRead: 'Als gelesen markieren',
    archive: 'Archiv',
    expiresIn: 'Läuft ab in',
    minute: 'Minute',
    minutes: 'Minuten',
    hour: 'Stunde',
    hours: 'Stunden',
    day: 'Tag',
    days: 'Tage',
    week: 'Woche',
    weeks: 'Wochen',
    month: 'Monat',
    months: 'Monate',
    year: 'Jahr',
    years: 'Jahre',
    connecting: 'Verbindung wird hergestellt…',
    connectionIssue:
      'Es scheint ein Verbindungsproblem zu geben. Neue Benachrichtigungen können verzögert werden oder verloren gehen.',
    offlineMessage:
      'Du bist offline. Lade die Seite neu, um Benachrichtigungen zu aktualisieren, sobald die Verbindung wieder da ist.',
    authError:
      'Benachrichtigungen können aufgrund eines Authentifizierungs- oder Berechtigungsproblems nicht abgerufen werden.',
    reportIssue: 'Problem melden',
    refreshPage: 'Seite aktualisieren',
    issueReported: 'Problem gemeldet',
    reportLimitExceeded: 'Meldelimit überschritten. Versuche es später erneut.',
  },
};

export default de;
